import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPost } from "../../../config/fetchWrapper";

export const RetrieveCustomPlaybookListAction = createAsyncThunk(
    "retrieveCustomPlaybookList",
    async (arg, { rejectWithValue }) => {
        try {
            const responseData = await doPost(urls?.retrieveCustomPlaybookQuestions, arg);
            return responseData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const retrieveCustomPlaybookListSlice = createSlice({
    name: "retrieveCustomPlaybookList",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        retrieveCustomPlaybookListReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        },
    },
    extraReducers: {
        [RetrieveCustomPlaybookListAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = null;
        },
        [RetrieveCustomPlaybookListAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = null;
            state.data = payload;
        },
        [RetrieveCustomPlaybookListAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const { retrieveCustomPlaybookListReset } = retrieveCustomPlaybookListSlice.actions;
export default retrieveCustomPlaybookListSlice.reducer;
